import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const store = new Vuex.Store({
    state :{
        lecture_id:'',      //讲座id
        set_book:{},        //书信息
        userInfo:[],        //用户信息
        // recommend_book:null,     //图书荐购is_see
        search_records:[],       //图书搜索记录
        search_work: '',         //图书搜索词
        conditions_index:{}      //搜索条件
    },
    mutations,
    actions,
    getters,
    // modules
})

export default store


// WEBPACK FOOTER //
// ./src/store/store.js